import type { ENV } from "@monta/env";
import { fixString } from "./fixString";
import type { MontaLinkProps } from "./types";

const fixBaseURL = (url: string, baseURL?: keyof ENV): string => {
  if (!url || !baseURL) return url;
  return fixString(url, baseURL);
};

export const Link = function (props: MontaLinkProps) {
  const { href, baseURL } = props;
  const newProps = { ...props };
  if (baseURL && href) newProps.href = fixBaseURL(href.toString(), baseURL);
  delete newProps.baseURL;
  return <a {...newProps} />;
};
